import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import DealerOrderReviewSummaryBody from "./DealerOrderReviewSummaryBody";

export default function DealerOrderReviewModal({
  isOpen,
  projectId,
  projectName,
  meta,
  priceMeta,
  buyerPayable,
  dealerPayable,
  margin,
  creditAdjustmentsTotal = 0,
  onClose,
  onAccept,
  accepting = false,
  showAcceptButton = true,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [summaryData, setSummaryData] = useState(null);

  useEffect(() => {
    if (!isOpen || !projectId) {
      setSummaryData(null);
      setError(null);
      return;
    }

    const dealerMeta = meta && typeof meta === "object" ? meta : null;
    const buyerMeta =
      priceMeta && typeof priceMeta === "object" ? priceMeta : null;

    if (dealerMeta || buyerMeta) {
      setSummaryData({
        data: {
          dealer_price_meta: dealerMeta,
          price_meta: buyerMeta,
        },
      });
      setError(null);
      setLoading(false);
      return;
    }

    setSummaryData(null);
    setError(null);
    setLoading(false);
  }, [isOpen, projectId, meta, priceMeta]);

  const title = "Review order";
  const subtitle =
    String(projectName || "").trim() ||
    (projectId != null ? `Order #${projectId}` : "");

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="md">
      <ModalHeader toggle={onClose}>
        <div>
          <div>{title}</div>
          {subtitle ? (
            <div className="small text-muted fw-normal">{subtitle}</div>
          ) : null}
        </div>
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <div className="py-4 text-center">
            <Spinner />
          </div>
        ) : error ? (
          <Alert color="danger" fade={false} className="mb-0">
            {error}
          </Alert>
        ) : (
          <DealerOrderReviewSummaryBody
            summaryData={summaryData}
            buyerPayable={buyerPayable}
            dealerPayable={dealerPayable}
            margin={margin}
            creditAdjustmentsTotal={creditAdjustmentsTotal}
          />
        )}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-between">
        <Button
          color="secondary"
          outline
          onClick={onClose}
          disabled={accepting}
        >
          {showAcceptButton ? "Cancel" : "Close"}
        </Button>
        {showAcceptButton ? (
          <Button
            color="success"
            onClick={() => onAccept?.(projectId)}
            disabled={loading || Boolean(error) || accepting}
          >
            {accepting ? "Accepting…" : "Accept order"}
          </Button>
        ) : null}
      </ModalFooter>
    </Modal>
  );
}
